import React, { Component } from 'react'
import { connect } from 'react-redux'
import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import axios from 'axios'
import { Preloader } from '../../components/Chart/index'
import './style.css'
import Multi from '../../components/Multi'
import Highlight from 'react-highlight'
import 'highlight.js/styles/foundation.css'
import ReactTooltip from 'react-tooltip'
import { isAdmin } from '../../lib/check-user'
import config from '../../config'
import ACLCheckPermission from '../../components/ACLCheckPermission'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import SessionService from '../../lib/services/SessionService'

// for tooltips
//import $ from 'jquery'

class SettingsServerToServer extends Component {
    debouncedFilter = null

    state = {
        copySnippetLabel: 'Copy snippet',
        uploadBucket: '',
        uploadBucketEU: '',
        loading: false,
        data: null,
        roleArn: 'arn:aws:iam::<YOUR_AWS_ACCOUNT_NUMBER>:user/<YOUR_AWS_USER>',
        uuidSnippet: '<img src="https://a.audrte.com/get?p=@PARTNER@&r=https://ad.yoururl.com/pixel?user_id=$UID" height=1 width=1>',
        uuidSnippetEU: '<img src="https://a.audrte.com/get?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_742}&p=@PARTNER@&r=https://ad.yoururl.com/pixel?user_id=$UID" height=1 width=1>',
        uuidSnippetMatch: '<img src="https://a.audrte.com/match?uid=<YOUR_UUID>&p=@PARTNER@" height=1 width=1>',
        uuidSnippetMatchEU: '<img src="https://a.audrte.com/match?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_742}&uid=<YOUR_UUID>&p=@PARTNER@" height=1 width=1>',
        showSDKSnippet: false,
        showSDKUploadSnippet: false,
        sdkSnippet: `
package com.audiencerate.dashboard.sdk.api.examples;

import com.amazonaws.auth.AWSStaticCredentialsProvider;
import com.amazonaws.auth.BasicAWSCredentials;
import com.amazonaws.regions.Regions;
import com.amazonaws.services.cognitoidp.AWSCognitoIdentityProviderClientBuilder;
import com.audiencerate.dashboard.sdk.api.DashboardAPI;
import com.audiencerate.dashboard.sdk.api.exceptions.DashboardHttpException;
import com.audiencerate.dashboard.sdk.api.exceptions.DashboardMappingException;
import com.audiencerate.dashboard.sdk.api.models.DashboardCredentials;
import com.audiencerate.dashboard.sdk.api.models.requests.DashboardGetRequest;
import com.audiencerate.dashboard.sdk.api.models.requests.DashboardPostRequest;
import com.audiencerate.dashboard.sdk.api.models.responses.DashboardListResponse;
import com.audiencerate.dashboard.sdk.api.models.responses.DashboardSingleResponse;
import java.util.HashMap;
import java.util.List;
import java.util.Map;
        
public class ConsoleExampleApplication
{
    public static void main(String... args)
    {
        /*** This is a console application built as tutorial ***/

        /*** First Step: Cognito Login: ***/

        BasicAWSCredentials basicAWSCredentials = new BasicAWSCredentials("IAM_ACCESS_KEY", "IAM_SECRET_KEY");

        String email = "@@YOUR_EMAIL@@";
        String password = "YOUR_USER_PASSWORD";
        String clientId = "@@THE_CLIENT_ID@@";
        String endpoint = "@@END_POINT@@";


        /*** Note that as default we use the US_EAST_REGION ***/

        DashboardCredentials credentials = new DashboardCredentials(email, password, Regions.US_EAST_1);


        DashboardAPI dashboardAPI  = DashboardAPI.newBuilder()
                .withEndpoint(endpoint)
                .withCredentials(credentials)
                .withClientId(clientId)
                .withCognitoClient(AWSCognitoIdentityProviderClientBuilder.standard()
                        .withRegion(Regions.US_EAST_1)
                        .withCredentials(new AWSStaticCredentialsProvider(basicAWSCredentials))
                        .build())
                .build();



        /*** Step 2: make a GET and A POST ***/

        Map<String, Object> getMap = new HashMap<>();
        getMap.put("offset", 0);
        getMap.put("size", 10);
        getMap.put("filter", "");
        getMap.put("sort", "audienceName");
        getMap.put("sortOrder", "asc");

        DashboardGetRequest getRequest = new DashboardGetRequest()
                .withPath("/audience")
                .withData(getMap);

        /*** GET call() method ***/
        DashboardListResponse response = null;

        try
        {
            response = dashboardAPI.call(getRequest);
        }
        catch (DashboardHttpException | DashboardMappingException e)
        {
            e.printStackTrace();
        }


        List<Audience> body = null;
        try
        {
            body = response.getBodyAsList(Audience.class);
        } catch (DashboardMappingException e)
        {
            e.printStackTrace();
        }


        System.out.println(body.toString());




        /*** Build a POST request for an Audience ***/

        Map<String, Object> postMap = new HashMap<>();
        postMap.put("audienceName", "Audience Name");
        postMap.put("branded", 1);                           // optional parameter
        postMap.put("description", "Audience description");  // optional parameter

        DashboardPostRequest postRequest =  new DashboardPostRequest()
                .withPath("/audience")
                .withData(postMap);

        DashboardSingleResponse responseMessage = null;

        try
        {
            /*** POST call() method ***/
            responseMessage = dashboardAPI.call(postRequest);
        } catch (DashboardHttpException | DashboardMappingException e)
        {
            e.printStackTrace();
        }

        Audience audience = null;
        try
        {
            audience = responseMessage.getBody(Audience.class);
        } catch (DashboardMappingException e)
        {
            e.printStackTrace();
        }

        System.out.println(audience.toString());

    }
}
        `,
        sdkUploadSnippet: `
package com.audiencerate.dashboard.sdk.api.examples;

import com.amazonaws.SdkClientException;
import com.amazonaws.auth.AWSStaticCredentialsProvider;
import com.amazonaws.auth.BasicAWSCredentials;
import com.amazonaws.auth.BasicSessionCredentials;
import com.amazonaws.regions.Regions;
import com.amazonaws.services.cognitoidp.AWSCognitoIdentityProviderClientBuilder;
import com.amazonaws.services.s3.AmazonS3;
import com.amazonaws.services.s3.AmazonS3ClientBuilder;
import com.amazonaws.services.s3.model.*;
import com.amazonaws.services.securitytoken.AWSSecurityTokenService;
import com.amazonaws.services.securitytoken.AWSSecurityTokenServiceClientBuilder;
import com.amazonaws.services.securitytoken.model.AssumeRoleRequest;
import com.amazonaws.services.securitytoken.model.AssumeRoleResult;
import com.amazonaws.services.securitytoken.model.GetCallerIdentityRequest;
import com.amazonaws.services.securitytoken.model.GetCallerIdentityResult;
import com.audiencerate.dashboard.sdk.api.DashboardAPI;
import com.audiencerate.dashboard.sdk.api.exceptions.DashboardHttpException;
import com.audiencerate.dashboard.sdk.api.exceptions.DashboardMappingException;
import com.audiencerate.dashboard.sdk.api.models.DashboardCredentials;
import com.audiencerate.dashboard.sdk.api.models.requests.DashboardPostRequest;
import com.audiencerate.dashboard.sdk.api.models.responses.DashboardSingleResponse;

import java.io.File;
import java.util.ArrayList;
import java.util.HashMap;
import java.util.List;
import java.util.Map;

public class ConsoleExampleUploader
{
    public static void main (String... args)
    {

        /**
         * FIRST STEP: Get the aws security token, assume the IAM role and start a session;
         */

        BasicAWSCredentials basicAWSCredentials = new BasicAWSCredentials("IAM_ACCESS_KEY", "IAM_SECRET_KEY");

        String clientRegion = Regions.US_EAST_1;
        String roleARN = "AWS_ROLE_ARN";
        String roleSessionName = "AWS_ROLE_SESSION_NAME";
        String bucketName = "@@THE_BUCKET_NAME@@";
        String file = "THE_FILE_TO_UPLOAD";

        String email = "@@YOUR_EMAIL@@";
        String password = "YOUR_USER_PASSWORD";
        String clientId = "@@THE_CLIENT_ID@@";
        String endpoint = "@@END_POINT@@";

        try
        {
            // Creating the STS client is part of your trusted code. It has
            // the security credentials you use to obtain temporary security credentials.

            AWSSecurityTokenService stsClient = AWSSecurityTokenServiceClientBuilder.standard()
                    .withCredentials(new AWSStaticCredentialsProvider(basicAWSCredentials))
                    .withRegion(clientRegion)
                    .build();


            // Assume the IAM role. Note that you cannot assume the role of an AWS root account;
            // Amazon S3 will deny access. You must use credentials for an IAM user or an IAM role.

            AssumeRoleRequest roleRequest = new AssumeRoleRequest()
                    .withRoleArn(roleARN)
                    .withRoleSessionName(roleSessionName);
            AssumeRoleResult assumeResult = stsClient.assumeRole(roleRequest);


            // Start a session.
            BasicSessionCredentials temporaryCredentials =
                    new BasicSessionCredentials(
                            assumeResult.getCredentials().getAccessKeyId(),
                            assumeResult.getCredentials().getSecretAccessKey(),
                            assumeResult.getCredentials().getSessionToken());

            /**
             * SECOND STEP: Get a caller identity, build an s3 client, list and put in the bucket a file.
             */

            // GET CALLER IDENTITY

            GetCallerIdentityRequest request = new GetCallerIdentityRequest()
                    .withRequestCredentialsProvider(new AWSStaticCredentialsProvider(temporaryCredentials));

            /**
             * The identity variable contains:
             * UserId;
             * Account;
             * Arn;
             */

            /**
             * identity is not used, but you can use it to get infos on the
             * user like: identity.getAccount()
             */
            GetCallerIdentityResult identity = stsClient.getCallerIdentity(request);


            // Provide temporary security credentials so that the Amazon S3 client
            // can send authenticated requests to Amazon S3. You create the client
            // using the basicSessionCredentials object.

            AmazonS3 s3Client = AmazonS3ClientBuilder.standard()
                    .withCredentials(new AWSStaticCredentialsProvider(temporaryCredentials))
                    .withRegion(clientRegion)
                    .build();


            // Verify that assuming the role worked and the permissions are set correctly
            // by getting a set of object keys from the bucket.

            /*** LIST OBJECTS ***/

            /**
             * The prefix is built in this way:
             * A_USER_LIST/A_USER/
             */

            ObjectListing objectListing = s3Client.listObjects(bucketName, "A_USER_LIST/A_USER" + "/");

            // JUST FOR DEBUG
            objectListing.getObjectSummaries().size();

            /*** PUT A FILE ***/

            File f = new File(file);

            /**
             * The key is built in this way:
             * The key: A_USER_LIST/A_USER/
             */

            PutObjectRequest putObjectRequest = new PutObjectRequest(bucketName, "A_USER_LIST/A_USER" + "/" +f.getName(), f);
            putObjectRequest.setCannedAcl(CannedAccessControlList.BucketOwnerFullControl);


            PutObjectResult putObjectResult = s3Client.putObject(putObjectRequest);

            // JUST FOR DEBUG
            ObjectMetadata metadata = putObjectResult.getMetadata();

            // When you put an object on S3, it will be versioned by S3.
            System.out.println("Version id: " + metadata.getVersionId());

            /*** THIRD STEP ***/

            /***
             * Notify that the audience was uploaded.
             */

            DashboardCredentials credentials = new DashboardCredentials(email, password, Regions.US_EAST_1);

            DashboardAPI dashboardAPI  = DashboardAPI.newBuilder()
                    .withEndpoint(endpoint)
                    .withCredentials(credentials)
                    .withClientId(clientId)
                    .withCognitoClient(AWSCognitoIdentityProviderClientBuilder.standard()
                            .withRegion(Regions.US_EAST_1)
                            .withCredentials(new AWSStaticCredentialsProvider(basicAWSCredentials))
                            .build())
                    .build();

            List<String> s3Files = new ArrayList<>();
            s3Files.add("@@THE_BUCKET_NAME@@A_FILE.csv");

            Map<String, Object> notificationMap = new HashMap<>();
            notificationMap.put("audienceId", "AN_AUDIENCE_ID");
            notificationMap.put("cookieType", "A_COOKIE_TYPE");
            notificationMap.put("fileList", s3Files);

            DashboardPostRequest postRequest = new DashboardPostRequest()
                    .withData(notificationMap)
                    .withPath("/upload_notification");

            DashboardSingleResponse response = null;

            /**
             * Send the notify upload post request.
             */

            try
            {
                response = dashboardAPI.call(postRequest);
            }
            catch (DashboardMappingException | DashboardHttpException e)
            {
                e.printStackTrace();
                return;
            }

            Map<String, Object> bodyMap = null;
            try
            {
                bodyMap = response.getBody(Map.class);

            }
            catch (DashboardMappingException e)
            {
                e.printStackTrace();
                return;
            }

            System.out.println(response.getBody(Map.class));
        }
        catch(DashboardMappingException | SdkClientException e)
        {
            // The call was transmitted successfully, but Amazon S3 couldn't process
            // it, so it returned an error response.
            e.printStackTrace();
        }// Amazon S3 couldn't be contacted for a response, or the client
// couldn't parse the response from Amazon S3.


    }
}        
        `,

        showCMDLoginSnippet: false,
        cmdLoginSnippet: `
        #! /bin/bash

        # use your Audiencerate dashboard credentials:
        username="@@YOUR_EMAIL@@"
        password="yourpassword"
        clientid="@@THE_CLIENT_ID@@"
        region="us-east-1"
        
        # 1 - get an aws cognito temporary auth token, so we can make API calls
        token_request=\`aws cognito-idp initiate-auth --auth-flow USER_PASSWORD_AUTH --output json --region $region --client-id $clientid \\
            --auth-parameters USERNAME=$username,PASSWORD=$password\`
        
        # 1b - extract the field IdToken from json response:
        id_token=\`echo $token_request | jq -r ".AuthenticationResult.IdToken"\`

        # 2 - call for example the API to fetch some audiences:
        # NOTE: to authenticate the request we use the Header 'Authentication' with the IdToken fetched before.
        curl '@@END_POINT@@/audience?offset=0&size=10&filter=&sort=creation&sortOrder=desc' -H 'Authentication: '$id_token \\
            -H 'Content-Type: application/json;charset=UTF-8'
        `,

        showCMDUploadSnippet: false,
        cmdUploadS3Snippet: `
        #! /bin/bash

        # 1 - upload a file using aws s3 cli
        aws s3 cp --profile audiencerate-profile --region us-east-1 test.txt @@THE_BUCKET_NAME@@
        
        # use your Audiencerate dashboard credentials:
        username="@@YOUR_EMAIL@@"
        password="yourpassword"
        clientid="@@THE_CLIENT_ID@@"
        region="us-east-1"
        
        # 2 - get an aws cognito temporary auth token, so we can make API calls
        token_request=\`aws cognito-idp initiate-auth --auth-flow USER_PASSWORD_AUTH --output json --region $region --client-id $clientid \\
            --auth-parameters USERNAME=$username,PASSWORD=$password\`
        
        # 2b - extract the field IdToken from json response:
        id_token=\`echo $token_request | jq -r ".AuthenticationResult.IdToken"\`

        # 3 - call the API "upload notification" to Audiencerate Dashboard of the newly uploaded file:
        # NOTE: to authenticate the request we use the Header 'Authentication' with the IdToken fetched before.
        curl '@@END_POINT@@/upload_notification' -X POST -H 'Authentication: '$id_token -H 'Content-Type: application/json;charset=UTF-8' \\
            --data-binary '{"audienceId":"AUDM69639067","cookieType":"mobile","fileList":["@@THE_BUCKET_NAME@@test2.txt"]}'
        
        # 4 - call the API "import events" to see the progress of a specific import, filtering by $TX_ID (transaction id):
        # NOTE: to authenticate the request we use the Header 'Authentication' with the IdToken fetched before.
        curl '@@END_POINT@@/event/import?filter=$TX_ID' -X GET -H 'Authentication: '$id_token -H 'Content-Type: application/json;charset=UTF-8' 

        `,

        showSDKPyUploadSnippet: false,
        sdkPyUploadSnippet: `
"""
AudienceRate API Example
"""

import requests
import boto3


class AudienceRateAPI():
    
    def __init__(self):
        # audiencerate config
        self.email = "@@YOUR_EMAIL@@"
        self.password = "COGNITO_USER_PASSWORD"
        self.clientId = "@@THE_CLIENT_ID@@"
        self.endpoint = "@@END_POINT@@"
        self.audienceType = "AN_AUDIENCE_TYPE" # e.g. mobile, etc.

        # aws config

        # access key and secret of the user assuming the role to upload to audiencerate s3 bucket
        self.aws_access_key_id = "YOUR_AWS_USER_ACCESS_KEY"
        self.aws_secret_access_key = "YOUR_AWS_USER_SECRET_KEY"
        self.region = "us-east-1"
        self.s3uploadBucket = "THE_BUCKET_NAME"
        self.partnerId = "PARTNER_ID" # e.g. p-xxxxxx
        self.s3uploadRoleARN = "AWS_ROLE_ARN"
        self.s3uploadRoleSessionName = "AWS_ROLE_SESSION_NAME"
        
        # login using access and secret keys of your user that has the associated
        # role arn to directly upload to Audiencerate S3
        self.aws_session = boto3.Session(
            aws_access_key_id=self.aws_access_key_id,
            aws_secret_access_key=self.aws_secret_access_key,
        )
        self.authenticate_via_aws_cognito()
        self.headers = {
            "Authentication" : self.idToken
        }
    

    """
    Perform username/password-based auth against AWS Cognito to get various auth tokens
    """
    def authenticate_via_aws_cognito(self):
        client = self.aws_session.client('cognito-idp', region_name=self.region)
        res = client.initiate_auth(
            AuthParameters={
                'USERNAME' : self.email,
                'PASSWORD' : self.password
            },
            ClientId=self.clientId,
            AuthFlow='USER_PASSWORD_AUTH'
        )        
        self.accessToken = res['AuthenticationResult']['AccessToken']
        self.idToken = res['AuthenticationResult']['IdToken']
        self.refreshToken = res['AuthenticationResult']['RefreshToken']


    """
    Create a shell audience
    
    Note: the full audience name includes a prefix based on the value of branded:
    branded: "Audiencerate: Branded Data > [Provider] > [audience name]"
    
    Returns the audience ID assigned by Audiencerate.
    """
    def create_audience(self, name, description, branded=True):        
        data = {
            "audienceName" : name,
            "description" : description,
            "branded" : 1 if branded else 0
        }
        path = f"{self.endpoint}/audience"
        res = requests.post(path, json=data, headers=self.headers)
        res.raise_for_status()
        json = res.json()        
        return json['body']['audienceId']


    """
    Upload audience file to S3.
    
    Returns true/false to indicate success.
    """
    def upload_audience_file(self, fileName, destFileName):
        # get temp security credentials so that the S3 client can send authenticated requests to S3
        sts_client = self.aws_session.client('sts', region_name=self.region)
        assumed_role = sts_client.assume_role(
            RoleArn=self.s3uploadRoleARN,
            RoleSessionName=self.s3uploadRoleSessionName
        )
        tmp_creds = assumed_role['Credentials']
        
        # create s3 client using temp credentials
        s3_client = boto3.client('s3',
                                 region_name=self.region,
                                 aws_access_key_id=tmp_creds['AccessKeyId'],
                                 aws_secret_access_key=tmp_creds['SecretAccessKey'],
                                 aws_session_token=tmp_creds['SessionToken'])

        # on to uploading
        object_data = None
        try:
            # possible FileNotFoundError/IOError exception            
            object_data = open(fileName, 'rb') 
            # possible ClientError
            #   AllAccessDisabled error == bucket not found
            #   NoSuchKey or InvalidRequest error == (dest bucket/obj == src bucket/obj)
            s3_client.put_object(
                Body=object_data,
                Bucket=self.s3uploadBucket,
                Key=f"partner={self.partnerId}/{destFileName}")
        except Exception as e:
            print(e)
            return False
        finally:
            if object_data:
                object_data.close()
        return True
    

    """
    Notify AudienceRate that a file was uploaded for a specified audience.
    
    Returns status of the API call.
    """
    def upload_notify(self, audienceId, destFileName):
        data = {
            "audienceId" : audienceId,
            "cookieType" : self.audienceType,
            "fileList" : [f"s3://{self.s3uploadBucket}/partner={self.partnerId}/{destFileName}"]
        }
        path = f"{self.endpoint}/upload_notification"
        res = requests.post(path, json=data, headers=self.headers)
        res.raise_for_status()
        json = res.json()
        return json['status'] == 'SUCCESS'



    '''
    # example usage:
    
    api = AudienceRateAPI()
    api.upload_audience_file('./test.csv', 'test.csv')
    print("notification", api.upload_notify("AUD1473208756", "test.csv"))
    
    '''

    

        `,

        cognitoUsername: '',
        cognitoClientId: '',
        apiUrl: '',

        chartOptions: null,
        timeRange: 'ONE_HOUR',
        period: 'ONE_MINUTES',

        partnerMetrics: null,

        partnerRegion: 'US',

    }

    // interpolate code snippet template
    getPersonalizedSDKCodeSnippet() {
        let email = SessionService.getUsernameLogged()
        let cognitoClientId = config.cognito.ClientId
        let apiUrl = config.apiUrl

        let sdkSnippet = this.state.sdkSnippet
            .replace('@@YOUR_EMAIL@@', email)
            .replace('@@THE_CLIENT_ID@@', cognitoClientId)
            .replace('@@END_POINT@@', new URL(apiUrl).origin)
        this.setState({ sdkSnippet: sdkSnippet })
    }
    // interpolate code snippet template
    getPersonalizedSDKUploadCodeSnippet() {
        let email = SessionService.getUsernameLogged()
        let cognitoClientId = config.cognito.ClientId
        let apiUrl = config.apiUrl

        let sdkUploadSnippet = this.state.sdkUploadSnippet
            .replace('@@YOUR_EMAIL@@', email)
            .replace('@@THE_CLIENT_ID@@', cognitoClientId)
            .replace('@@END_POINT@@', new URL(apiUrl).origin)
        // also change upload s3 url with custom url if the user has generated the IAM association, else show a default
        if (this.state.uploadBucket != '' && this.state.uploadBucket != undefined) {
            sdkUploadSnippet = sdkUploadSnippet.replace('@@THE_BUCKET_NAME@@', this.state.uploadBucket).replace('@@THE_BUCKET_NAME@@', this.state.uploadBucket)
            //sdkUploadSnippet = sdkUploadSnippet.replace('@@THE_BUCKET_NAME@@', this.state.uploadBucket)
        } else {
            sdkUploadSnippet = sdkUploadSnippet
                .replace('@@THE_BUCKET_NAME@@', 's3://BUCKET_NAME/partner=PARTNER_ID')
                .replace('@@THE_BUCKET_NAME@@', 's3://BUCKET_NAME/partner=PARTNER_ID')
        }
        this.setState({ sdkUploadSnippet: sdkUploadSnippet })
    }
    getPersonalizedCMDLoginCodeSnippet() {
        let email = SessionService.getUsernameLogged()
        let cognitoClientId = config.cognito.ClientId
        let apiUrl = config.apiUrl

        let cmdLoginSnippet = this.state.cmdLoginSnippet
            .replace('@@YOUR_EMAIL@@', email)
            .replace('@@THE_CLIENT_ID@@', cognitoClientId)
            .replace('@@END_POINT@@', new URL(apiUrl).origin)
        this.setState({ cmdLoginSnippet: cmdLoginSnippet })
    }
    // interpolate code snippet template
    getPersonalizedCMDUploadCodeSnippet() {
        let email = SessionService.getUsernameLogged()
        let cognitoClientId = config.cognito.ClientId
        let apiUrl = config.apiUrl

        let cmdUploadS3Snippet = this.state.cmdUploadS3Snippet
            .replace('@@YOUR_EMAIL@@', email)
            .replace('@@THE_CLIENT_ID@@', cognitoClientId)
            .replace('@@END_POINT@@', new URL(apiUrl).origin)
            .replace('@@END_POINT@@', new URL(apiUrl).origin)
        // also change upload s3 url with custom url if the user has generated the IAM association, else show a default
        if (this.state.uploadBucket != '' && this.state.uploadBucket != undefined) {
            cmdUploadS3Snippet = cmdUploadS3Snippet
                .replace('@@THE_BUCKET_NAME@@', this.state.uploadBucket)
                .replace('@@THE_BUCKET_NAME@@', this.state.uploadBucket)
            //sdkUploadSnippet = sdkUploadSnippet.replace('@@THE_BUCKET_NAME@@', this.state.uploadBucket)
        } else {
            cmdUploadS3Snippet = cmdUploadS3Snippet
                .replace('@@THE_BUCKET_NAME@@', 's3://BUCKET_NAME/partner=PARTNER_ID')
                .replace('@@THE_BUCKET_NAME@@', 's3://BUCKET_NAME/partner=PARTNER_ID')
        }
        this.setState({ cmdUploadS3Snippet: cmdUploadS3Snippet })
    }
    // interpolate code snippet template
    getPersonalizedSDKPyUploadCodeSnippet() {
        let email = SessionService.getUsernameLogged()
        let cognitoClientId = config.cognito.ClientId
        let apiUrl = config.apiUrl

        let sdkPyUploadSnippet = this.state.sdkPyUploadSnippet
            .replace('@@YOUR_EMAIL@@', email)
            .replace('@@THE_CLIENT_ID@@', cognitoClientId)
            .replace('@@END_POINT@@', new URL(apiUrl).origin)
        // also change upload s3 url with custom url if the user has generated the IAM association, else show a default
        if (this.state.uploadBucket != '' && this.state.uploadBucket != undefined) {
            sdkPyUploadSnippet = sdkPyUploadSnippet
                .replace('@@THE_BUCKET_NAME@@', this.state.uploadBucket)
                .replace('@@THE_BUCKET_NAME@@', this.state.uploadBucket)
            //sdkUploadSnippet = sdkUploadSnippet.replace('@@THE_BUCKET_NAME@@', this.state.uploadBucket)
        } else {
            sdkPyUploadSnippet = sdkPyUploadSnippet
                .replace('@@THE_BUCKET_NAME@@', 's3://BUCKET_NAME/partner=PARTNER_ID')
                .replace('@@THE_BUCKET_NAME@@', 's3://BUCKET_NAME/partner=PARTNER_ID')
        }
        this.setState({ sdkPyUploadSnippet: sdkPyUploadSnippet })
    }

    componentDidMount() {
        axios.get('/iamrole').then(response => {
            let data = (response.data.body && response.data.body[0]) || {}
            if (data && data.base64Policy) {
                data.base64Policy = atob(data.base64Policy)
            }
            this.setState({ data: data, roleArn: data.roleArn, uploadBucket: data.uploadBucket, uploadBucketEU: data.uploadBucketEU,  }, () => {
                // if the GET is successful, update also the data from IAM role
                this.getPersonalizedSDKUploadCodeSnippet()
                this.getPersonalizedCMDUploadCodeSnippet()
                this.getPersonalizedSDKPyUploadCodeSnippet()
            })
        })
        axios.get('/partner/metrics').then(response => {
            let data = (response.data.body && response.data.body[0]) || {}
            this.setState({ partnerMetrics: data }, () => {})
        })
        this.loadChartDmpSyncs()

        this.getPersonalizedSDKCodeSnippet()
        this.getPersonalizedCMDLoginCodeSnippet()

        let partner = this.getPartner()
        let partnerRegion = this.getPartnerRegion()
        let uuidSnippet = this.state.uuidSnippet.replace('@PARTNER@', partner)
        let uuidSnippetEU = this.state.uuidSnippetEU.replace('@PARTNER@', partner)
        let uuidSnippetMatch = this.state.uuidSnippetMatch.replace('@PARTNER@', partner)
        let uuidSnippetMatchEU = this.state.uuidSnippetMatchEU.replace('@PARTNER@', partner)

        this.setState({
            cognitoUsername: SessionService.getUsernameLogged(),
            cognitoClientId: config.cognito.ClientId,
            apiUrl: config.apiUrl,
            uuidSnippet: uuidSnippet,
            uuidSnippetEU: uuidSnippetEU,
            uuidSnippetMatch: uuidSnippetMatch,
            uuidSnippetMatchEU: uuidSnippetMatchEU,
            partnerRegion: partnerRegion,
        })
    }

    // Sub Partners CRUD
    onRoleArnChange(event) {
        this.setState({ roleArn: event.target.value })
    }

    onRoleSave() {
        console.log('onRoleSave')
        this.setState({ loading: true }, () => {
            axios
                .request({
                    url: '/iamrole',
                    method: 'POST',
                    data: {
                        roleArn: this.state.roleArn
                    }
                })
                .then(response => {
                    console.log('onRoleSave response', response)
                    let data = response.data.body
                    if (data && data.base64Policy) {
                        data.base64Policy = atob(data.base64Policy)
                    }
                    this.setState({ data: data, uploadBucket: data.uploadBucket, loading: false }, () => {
                        // if the SAVE is successful, update also the data from IAM role
                        this.getPersonalizedSDKUploadCodeSnippet()
                        this.getPersonalizedSDKUploadCodeSnippet()
                    })
                })
                .catch(err => {
                    console.error(err)
                    this.setState({ loading: false })
                })
        })
    }

    onRoleRemove() {
        console.log('onRoleRemove')
        this.setState({ loading: true }, () => {
            axios
                .request({
                    url: '/iamrole',
                    method: 'DELETE',
                    data: {
                        roleArn: this.state.roleArn
                    }
                })
                .then(response => {
                    console.log('onRoleRemove response', response)
                    this.setState({ data: {}, uploadBucket: '', loading: false }, () => {
                        // if the DELETE is successful, update also the data from IAM role
                        this.getPersonalizedSDKUploadCodeSnippet()
                        this.getPersonalizedSDKUploadCodeSnippet()
                    })
                })
        })
    }

    // copy this str passed to clipboard
    copyClipboard(str) {
        this.setState({ copySnippetLabel: 'Copied!' }, () => {
            const el = document.createElement('textarea')
            el.value = str
            document.body.appendChild(el)
            el.select()
            document.execCommand('copy')
            document.body.removeChild(el)

            let text = el.value
            console.log('copy text ', text)

            setTimeout(() => {
                this.setState({ copySnippetLabel: 'Copy snippet' })
            }, 1000)
        })
    }

    loadChartDmpSyncs() {
        axios.get('/event/dmpsyncs?timeRange=' + this.state.timeRange + '&period=' + this.state.period).then(response => {
            let data = response.data.body || []
            console.log('DMPSYNCS ', data)

            // if a partner doesn't have any metrics, we don't show any graph!
            if (data.length == 0) {
                return
            }

            // map data in 2 arrays: one for labels and one for values.
            let labels = []
            let values = []
            data.map(el => {
                labels.push(
                    new Date(el.label)
                        .toLocaleString()
                        .replace('/' + new Date().getFullYear(), '')
                        .replace(',', '')
                )
                values.push(el.value)
            })

            let chartOptions = {
                chart: {
                    type: 'area'
                },
                credits: {
                    enabled: false
                },
                title: {
                    //text: 'UUID Mapping Calls'
                    text: ''
                },
                xAxis: {
                    categories: []
                },
                yAxis: {
                    allowDecimals: false,
                    title: {
                        text: ''
                    }
                },
                series: [
                    {
                        name: 'Syncs',
                        data: []
                    }
                ]
            }
            chartOptions.xAxis.categories = labels
            chartOptions.series[0].data = values
            console.log('DMPSYNCS ', chartOptions)
            this.setState({ chartOptions: chartOptions }, () => {})
        })
    }

    onChangeTimeRange(timeRangeHours) {
        console.log('onChangeTimeRange: ', timeRangeHours)

        this.setState({ timeRange: timeRangeHours }, () => {
            this.loadChartDmpSyncs()
        })
    }
    onChangePeriod(period) {
        console.log('onChangePeriod: ', period)

        this.setState({ period: period }, () => {
            this.loadChartDmpSyncs()
        })
    }

    getPartner() {
        let partnerId = ''

        let partnerLogged = SessionService.getPartnerLogged()
        if (partnerLogged!=null) {
            partnerId = partnerLogged.partnerId
        }

        return partnerId.replace('p-', '')
    }

    getPartnerRegion(){
        let region = 'us'
       
        let partnerLogged = SessionService.getPartnerLogged()
        console.log("getPartnerRegion: " , partnerLogged)
        if (partnerLogged!=null) {
            region = partnerLogged.region
        }

        return region.toUpperCase()
    }

    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <Multi>
                        {!this.state.data ? (
                            <Preloader transparent />
                        ) : (
                            <div className="row">
                                <div className="col-12">
                                    <WhiteBox>
                                        <div className="row">
                                            <div className="col-12">
                                                {this.state.partnerMetrics != null && this.state.partnerMetrics.disabled && (
                                                    <div className="alert alert-warning">
                                                        Direct upload on Audiencerate S3 Bucket is temporarily disabled for this month because you have uploaded
                                                        more than 1TB of uncompressed data. To increase this limit please contact the{' '}
                                                        <a href="mailto:admin@audiencerate.com">support</a>.
                                                    </div>
                                                )}

                                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link active"
                                                            id="uuidmapping-tab"
                                                            data-toggle="tab"
                                                            href="#uuidmapping"
                                                            role="tab"
                                                            aria-controls="uuidmapping"
                                                            aria-selected="true">
                                                            UUID MAPPING
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link"
                                                            id="s3uploadsettings-tab"
                                                            data-toggle="tab"
                                                            href="#s3uploadsettings"
                                                            role="tab"
                                                            aria-controls="s3uploadsettings"
                                                            aria-selected="false">
                                                            UPLOAD S3 SETTINGS
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link"
                                                            id="apicredentials-tab"
                                                            data-toggle="tab"
                                                            href="#apicredentials"
                                                            role="tab"
                                                            aria-controls="apicredentials-tab"
                                                            aria-selected="false">
                                                            API CREDENTIALS
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link"
                                                            id="snippets-tab"
                                                            data-toggle="tab"
                                                            href="#snippets"
                                                            role="tab"
                                                            aria-controls="snippets"
                                                            aria-selected="false">
                                                            CODE SNIPPETS
                                                        </a>
                                                    </li>
                                                </ul>

                                                <div className="tab-content" id="myTabContent">
                                                    <div
                                                        className="tab-pane fade show active"
                                                        id="uuidmapping"
                                                        role="tabpanel"
                                                        aria-labelledby="uuidmapping-tab">
                                                        <div className="row" style={{ padding: '10px' }}>
                                                            <div className="col-12">
                                                                <p>
                                                                    To store the mapping on your end, you place a 1x1 image pixel on your pages that calls the
                                                                    AudienceRate <strong>get</strong> service and returns AudienceRate UUIDs to you for storage.
                                                                    Format the pixel as follows:
                                                                </p>

                                                                <ReactTooltip
                                                                    className="customeTooltipTheme"
                                                                    place="left"
                                                                    type="dark"
                                                                    effect="solid"
                                                                    getContent={[
                                                                        () => {
                                                                            return this.state.copySnippetLabel
                                                                        },
                                                                        3000
                                                                    ]}
                                                                />

                                                                <pre className="row">
                                                                    <div className="col-md-12" role="alert">
                                                                        <Highlight className="html">{this.state.partnerRegion === 'US' ? this.state.uuidSnippet : this.state.uuidSnippetEU}</Highlight>
                                                                    </div>
                                                                    <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                        <button
                                                                            className="btn btn-primary  btn-sm "
                                                                            onClick={this.copyClipboard.bind(this, this.state.partnerRegion === 'US' ? this.state.uuidSnippet : this.state.uuidSnippetEU)}>
                                                                            <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                        </button>
                                                                    </div>
                                                                </pre>

                                                                <p>
                                                                    A redirect URL should be specified in the get call, and it should contain the $UID macro.
                                                                    This macro will be replaced with the AudienceRate UUID when redirecting to the final URL,
                                                                    allowing the UUID to be taken in and mapped by your server.
                                                                </p>
                                                                <p>Here's what happens when a user views a page containing the pixel:</p>
                                                                <ol>
                                                                    <li>
                                                                        The browser calls the AudienceRate <strong>get</strong> service.
                                                                    </li>
                                                                    <li>
                                                                        The <strong>get</strong> service replaces the $UID macro in the redirect URL with the
                                                                        AudienceRate user ID (retrieved from the AudienceRate browser cookie).
                                                                    </li>
                                                                    <li>
                                                                        The call is redirected to the final URL, where you receive the AudienceRate user ID, map
                                                                        it to your ID for the user, and store the mapping in your system.
                                                                    </li>
                                                                </ol>
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ padding: '10px' }}>
                                                            <div className="col-12">
                                                                <hr/>
                                                                <p>
                                                                    This is the pixel mapping url to fill the matchtable hosted by Audiencerate. 
                                                                    <b>You need to contact Audiencerate support at <a href="mailto:admin@audiencerate.com">admin@audiencerate.com</a> to activate this endpoint</b>.
                                                                </p>

                                                                <ReactTooltip
                                                                    className="customeTooltipTheme"
                                                                    place="left"
                                                                    type="dark"
                                                                    effect="solid"
                                                                    getContent={[
                                                                        () => {
                                                                            return this.state.copySnippetLabel
                                                                        },
                                                                        3000
                                                                    ]}
                                                                />

                                                                <pre className="row">
                                                                    <div className="col-md-12" role="alert">
                                                                        <Highlight className="html">{this.state.partnerRegion === 'US' ? this.state.uuidSnippetMatch : this.state.uuidSnippetMatchEU}</Highlight>
                                                                    </div>
                                                                    <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                        <button
                                                                            className="btn btn-primary  btn-sm "
                                                                            onClick={this.copyClipboard.bind(this, this.state.partnerRegion === 'US' ? this.state.uuidSnippetMatch : this.state.uuidSnippetMatchEU)}>
                                                                            <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                        </button>
                                                                    </div>
                                                                </pre>
                                                                
                                                            </div>
                                                        </div>

                                                        {this.state.chartOptions != null && (
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="row" style={{ padding: '10px' }}>
                                                                        <div className="col-8">
                                                                            <h3>UUID Mapping sync metrics</h3>
                                                                        </div>
                                                                        <div className="col-4 text-right">
                                                                            <label>
                                                                                <b>Time Range&#160;</b>
                                                                            </label>
                                                                            <select onChange={e => this.onChangeTimeRange(e.target.value)}>
                                                                                <option value="ONE_HOUR">1 Hour</option>
                                                                                <option value="THREE_HOURS">3 Hours</option>
                                                                                <option value="EIGHT_HOURS">8 Hours</option>
                                                                                <option value="TWELVE_HOURS">12 Hours</option>
                                                                                <option value="ONE_DAY">1 Day</option>
                                                                                <option value="THREE_DAY">3 Days</option>
                                                                            </select>
                                                                            &#160;
                                                                            <label>
                                                                                <b>Period&#160;</b>
                                                                            </label>
                                                                            <select onChange={e => this.onChangePeriod(e.target.value)}>
                                                                                <option value="ONE_MINUTES">1 Minute</option>
                                                                                <option value="FIVE_MINUTES">5 Minutes</option>
                                                                                <option value="FIFTEEN_MINUTES">15 Minutes</option>
                                                                                <option value="THIRTY_MINUTES">30 Minutes</option>
                                                                                <option value="ONE_HOUR">1 Hour</option>
                                                                                <option value="SIX_HOURS">6 Hours</option>
                                                                                <option value="TWELVE_HOURS">12 Hours</option>
                                                                                <option value="TWENTY_HOURS">1 Day</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <HighchartsReact highcharts={Highcharts} options={this.state.chartOptions} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="tab-pane fade" id="s3uploadsettings" role="tabpanel" aria-labelledby="s3uploadsettings-tab">
                                                        <div className="row" style={{ padding: '10px' }}>
                                                            <div className="col-12">
                                                                <div className="form-group">
                                                                    <h3>IAM User ARN ID:</h3>
                                                                    <p>
                                                                        Please add a IAM User ARN from <u>your AWS account</u> to generate an S3 upload policy
                                                                        on AudienceRate Dashboard. With this policy attached to your user, you can upload
                                                                        directly on our bucket via AWS Cli or using an AWS SDK.
                                                                    </p>

                                                                    <input
                                                                        disabled={this.state.data && this.state.data.base64Policy}
                                                                        type="text"
                                                                        id="disabledTextInput"
                                                                        className="form-control"
                                                                        value={this.state.roleArn}
                                                                        onChange={e => this.onRoleArnChange(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row" style={{ padding: '10px' }}>
                                                            {this.state.data && !this.state.data.base64Policy && (
                                                                <div className="col-1">
                                                                    <ACLCheckPermission api="/iamrole" method="POST">
                                                                        <ReactTooltip id="saveS3BtnTooltip" type="dark" effect="solid">
                                                                            <span>Save S3 Upload Settings</span>
                                                                        </ReactTooltip>
                                                                        <button
                                                                            data-tip
                                                                            data-for="saveS3BtnTooltip"
                                                                            onClick={() => this.onRoleSave()}
                                                                            className="border-button white very-blue-bg ">
                                                                            Save
                                                                        </button>
                                                                    </ACLCheckPermission>
                                                                </div>
                                                            )}

                                                            {this.state.data && this.state.data.base64Policy && (
                                                                <div className="col">
                                                                    <ACLCheckPermission api="/iamrole" method="DELETE">
                                                                        <ReactTooltip id="deleteS3BtnTooltip" type="dark" effect="solid">
                                                                            <span>Delete S3 Upload Settings</span>
                                                                        </ReactTooltip>
                                                                        <button
                                                                            data-tip
                                                                            data-for="deleteS3BtnTooltip"
                                                                            onClick={() => this.onRoleRemove()}
                                                                            className="border-button white very-red-bg ">
                                                                            Delete
                                                                        </button>
                                                                    </ACLCheckPermission>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {this.state.data && this.state.data.base64Policy && <hr />}

                                                        {this.state.data && this.state.data.base64Policy && (
                                                            <div className="row" style={{ padding: '10px' }}>
                                                                <div className="col-12">
                                                                    <h3>IAM Assume Role Policy:</h3>

                                                                    <div className="form-group">
                                                                        <label htmlFor="disabledTextInput">
                                                                            Please attach this policy to your user <b>({this.state.roleArn})</b>:
                                                                        </label>

                                                                        <ReactTooltip
                                                                            className="customeTooltipTheme"
                                                                            place="left"
                                                                            type="dark"
                                                                            effect="solid"
                                                                            getContent={[
                                                                                () => {
                                                                                    return this.state.copySnippetLabel
                                                                                },
                                                                                3000
                                                                            ]}
                                                                        />

                                                                        <pre className="row">
                                                                            <div className="col-md-12" role="alert">
                                                                                <Highlight className="json">{this.state.data.base64Policy}</Highlight>
                                                                            </div>
                                                                            <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                                <button
                                                                                    className="btn btn-primary  btn-sm  "
                                                                                    onClick={this.copyClipboard.bind(this, this.state.data.base64Policy)}>
                                                                                    <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                                </button>
                                                                            </div>
                                                                        </pre>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {this.state.uploadBucket && (
                                                            <div className="row" style={{ padding: '10px' }}>
                                                                <div className="col-12">
                                                                    <div className="form-group">
                                                                        <h3>S3 Upload Bucket:</h3>
                                                                        <p>This is the S3 bucket that you will use to upload segment files in <b>United States</b>.</p>

                                                                        <ReactTooltip
                                                                            className="customeTooltipTheme"
                                                                            place="left"
                                                                            type="dark"
                                                                            effect="solid"
                                                                            getContent={[
                                                                                () => {
                                                                                    return this.state.copySnippetLabel
                                                                                },
                                                                                3000
                                                                            ]}
                                                                        />

                                                                        <pre className="row">
                                                                            <div className="col-md-12" role="alert">
                                                                                <Highlight className="html">{this.state.uploadBucket}</Highlight>
                                                                            </div>
                                                                            <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                                <button
                                                                                    className="btn btn-primary btn-sm "
                                                                                    onClick={this.copyClipboard.bind(this, this.state.uploadBucket)}>
                                                                                    <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                                </button>
                                                                            </div>
                                                                        </pre>


                                                                        
                                                                        <p>This is the S3 bucket that you will use to upload segment files in <b>Europe</b>.</p>

                                                                        <ReactTooltip
                                                                            className="customeTooltipTheme"
                                                                            place="left"
                                                                            type="dark"
                                                                            effect="solid"
                                                                            getContent={[
                                                                                () => {
                                                                                    return this.state.copySnippetLabel
                                                                                },
                                                                                3000
                                                                            ]}
                                                                        />

                                                                        <pre className="row">
                                                                            <div className="col-md-12" role="alert">
                                                                                <Highlight className="html">{this.state.uploadBucketEU}</Highlight>
                                                                            </div>
                                                                            <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                                <button
                                                                                    className="btn btn-primary btn-sm "
                                                                                    onClick={this.copyClipboard.bind(this, this.state.uploadBucketEU)}>
                                                                                    <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                                </button>
                                                                            </div>
                                                                        </pre>



                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {this.state.data && this.state.data.base64Policy && <hr />}
                                                        {this.state.data && this.state.data.base64Policy && (
                                                            <div className="row" style={{ padding: '10px' }}>
                                                                <div className="col-12">
                                                                    <h3>AWS CLI Configuration</h3>
                                                                    <p>If you are going to use the AWS CLI for segments upload, configure it like this:</p>
                                                                    <p>
                                                                        <ol>
                                                                            <li>
                                                                                Add a new profile:
                                                                                <br />
                                                                                <Highlight className="bash">aws configure --profile audiencerate-cli-us</Highlight>
                                                                                <Highlight className="bash">aws configure --profile audiencerate-cli-eu</Highlight>
                                                                            </li>
                                                                            <li>
                                                                                Edit the aws credentials files to use the "assume role" property, so that you
                                                                                can directly upload to our S3 bucket:
                                                                                <br />
                                                                                <br />
                                                                                - edit the <u>.aws/config</u> file:
                                                                                <br />
                                                                                <br />
                                                                                This is the profile to upload on United States bucket:
                                                                                <Highlight className="bash">
                                                                                    [profile audiencerate-cli-us]
                                                                                    <br />
                                                                                    aws_access_key_id = YOUR_AWS_USER_ACCESS_KEY
                                                                                    <br />
                                                                                    aws_secret_access_key = YOUR_AWS_USER_SECRET_KEY
                                                                                    <br />
                                                                                    output = json
                                                                                    <br />
                                                                                    region = us-east-1
                                                                                    <br />
                                                                                </Highlight>

                                                                                <br/>
                                                                                This is the profile to upload on European bucket:

                                                                                <Highlight className="bash">
                                                                                    [profile audiencerate-cli-eu]
                                                                                    <br />
                                                                                    aws_access_key_id = YOUR_AWS_USER_ACCESS_KEY
                                                                                    <br />
                                                                                    aws_secret_access_key = YOUR_AWS_USER_SECRET_KEY
                                                                                    <br />
                                                                                    output = json
                                                                                    <br />
                                                                                    region = eu-west-1
                                                                                    <br />
                                                                                </Highlight>
                                                                                <br />- edit the <u>.aws/credentials</u> file and{' '}
                                                                                <u>add the role arn you got from the policy generated</u>:
                                                                                <br />
                                                                                <Highlight className="bash">
                                                                                    [audiencerate-cli-us]
                                                                                    <br />
                                                                                    role_arn = ROLE_ARN_RESOURCE_YOU_GOT_FROM_GENERATED_POLICY
                                                                                    <br />
                                                                                    source_profile = audiencerate-cli-us
                                                                                    <br />
                                                                                </Highlight>
                                                                                <Highlight className="bash">
                                                                                    [audiencerate-cli-eu]
                                                                                    <br />
                                                                                    role_arn = ROLE_ARN_RESOURCE_YOU_GOT_FROM_GENERATED_POLICY
                                                                                    <br />
                                                                                    source_profile = audiencerate-cli-eu
                                                                                    <br />
                                                                                </Highlight>
                                                                            </li>
                                                                            <li>
                                                                                Try out new profile with assumed role:
                                                                                <br />
                                                                                <br />
                                                                                - list <br />
                                                                                <Highlight className="bash">
                                                                                    aws s3 ls --profile audiencerate-cli-us --region us-east-1{' '}
                                                                                    {this.state.uploadBucket}
                                                                                    <br />
                                                                                    aws s3 ls --profile audiencerate-cli-eu --region eu-west-1{' '}
                                                                                    {this.state.uploadBucketEU}
                                                                                    <br />
                                                                                </Highlight>
                                                                                <br />
                                                                                - upload <br />
                                                                                <Highlight className="bash">
                                                                                    aws s3 cp --profile audiencerate-cli --region us-east-1 test.csv{' '}
                                                                                    {this.state.uploadBucket}
                                                                                    <br/>
                                                                                    aws s3 cp --profile audiencerate-cli --region us-east-1 test.csv{' '}
                                                                                    {this.state.uploadBucketEU}
                                                                                </Highlight>
                                                                            </li>
                                                                        </ol>
                                                                        <br />
                                                                        For more informations, follow the official manual:{' '}
                                                                        <a href="https://docs.aws.amazon.com/cli/latest/userguide/cli-configure-role.html">
                                                                            Using an IAM Role in the AWS CLI
                                                                        </a>
                                                                        .
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {this.state.loading && <Preloader transparent />}
                                                    </div>
                                                    <div className="tab-pane fade" id="apicredentials" role="tabpanel" aria-labelledby="apicredentials-tab">
                                                        <div className="row" style={{ padding: '10px' }}>
                                                            <div className="col-12">
                                                                All the Audiencerate APIs are authenticated under <b>AWS Cognito OAuth2 Service</b>.
                                                                <br />
                                                                <br />
                                                                Use your Audiencerate Dashboard credentials (<u>Username</u> and <u>Password</u>) and{' '}
                                                                <u>Cognito Client ID</u> to login to <b>AWS Cognito</b> using{' '}
                                                                <a href="https://aws.amazon.com/tools/">AWS SDK</a> or{' '}
                                                                <a href="https://aws.amazon.com/cli/">AWS CLI</a> before making an API call to Audiencerate
                                                                APIs.
                                                                <br />
                                                                <br />
                                                                Read more infos here: <a href="/doc/api">API Access Documentation</a> and see the{' '}
                                                                <b>Code Snippets</b> examples to see how it works.
                                                                <br />
                                                                <hr />
                                                                <div className="form-group">
                                                                    <label htmlFor="disabledTextInput">Cognito Username:</label>

                                                                    <ReactTooltip
                                                                        className="customeTooltipTheme"
                                                                        place="left"
                                                                        type="dark"
                                                                        effect="solid"
                                                                        getContent={[
                                                                            () => {
                                                                                return this.state.copySnippetLabel
                                                                            },
                                                                            3000
                                                                        ]}
                                                                    />

                                                                    <pre className="row">
                                                                        <div className="col-md-12" role="alert">
                                                                            <Highlight className="html">{this.state.cognitoUsername}</Highlight>
                                                                        </div>
                                                                        <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                            <button
                                                                                className="btn btn-primary btn-sm "
                                                                                onClick={this.copyClipboard.bind(this, this.state.cognitoUsername)}>
                                                                                <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                            </button>
                                                                        </div>
                                                                    </pre>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ padding: '10px' }}>
                                                            <div className="col-12">
                                                                <div className="form-group">
                                                                    <label htmlFor="disabledTextInput">Cognito Client ID:</label>

                                                                    <ReactTooltip
                                                                        className="customeTooltipTheme"
                                                                        place="left"
                                                                        type="dark"
                                                                        effect="solid"
                                                                        getContent={[
                                                                            () => {
                                                                                return this.state.copySnippetLabel
                                                                            },
                                                                            3000
                                                                        ]}
                                                                    />

                                                                    <pre className="row">
                                                                        <div className="col-md-12" role="alert">
                                                                            <Highlight className="html">{this.state.cognitoClientId}</Highlight>
                                                                        </div>
                                                                        <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                            <button
                                                                                className="btn btn-primary btn-sm "
                                                                                onClick={this.copyClipboard.bind(this, this.state.cognitoClientId)}>
                                                                                <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                            </button>
                                                                        </div>
                                                                    </pre>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ padding: '10px' }}>
                                                            <div className="col-12">
                                                                <div className="form-group">
                                                                    <label htmlFor="disabledTextInput">Audiencerate API URL:</label>

                                                                    <ReactTooltip
                                                                        className="customeTooltipTheme"
                                                                        place="left"
                                                                        type="dark"
                                                                        effect="solid"
                                                                        getContent={[
                                                                            () => {
                                                                                return this.state.copySnippetLabel
                                                                            },
                                                                            3000
                                                                        ]}
                                                                    />

                                                                    <pre className="row">
                                                                        <div className="col-md-12" role="alert">
                                                                            <Highlight className="html">{this.state.apiUrl}</Highlight>
                                                                        </div>
                                                                        <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                            <button
                                                                                className="btn btn-primary btn-sm "
                                                                                onClick={this.copyClipboard.bind(this, this.state.apiUrl)}>
                                                                                <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                            </button>
                                                                        </div>
                                                                    </pre>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {this.state.loading && <Preloader transparent />}
                                                    </div>
                                                    <div className="tab-pane fade" id="snippets" role="tabpanel" aria-labelledby="snippets-tab">
                                                        <div className="row">
                                                            <div className="col">
                                                                <h3>Java SDK Code Snippet</h3>
                                                            </div>
                                                        </div>

                                                        <div className="row" style={{ padding: '10px' }}>
                                                            <div className="col-12">
                                                                <p>
                                                                    This is an example of integration with the AudienceRate SDK in Java: (for more info check
                                                                    out our library here:{' '}
                                                                    <a target="_blank" href="https://github.com/audiencerate/dashboard-api-sdk">
                                                                        https://github.com/audiencerate/dashboard-api-sdk
                                                                    </a>
                                                                    ) &#160;
                                                                    <a
                                                                        className="btn btn-primary btn-sm"
                                                                        data-toggle="collapse"
                                                                        href="#collapseExample"
                                                                        role="button"
                                                                        aria-expanded="false"
                                                                        aria-controls="collapseExample"
                                                                        onClick={() => {
                                                                            this.setState({ showSDKSnippet: !this.state.showSDKSnippet })
                                                                        }}>
                                                                        {!this.state.showSDKSnippet && <span>Show</span>}
                                                                        {this.state.showSDKSnippet && <span>Hide</span>}
                                                                    </a>
                                                                </p>

                                                                <div style={{ display: this.state.showSDKSnippet ? 'block' : 'none' }}>
                                                                    <ReactTooltip
                                                                        className="customeTooltipTheme"
                                                                        place="left"
                                                                        type="dark"
                                                                        effect="solid"
                                                                        getContent={[
                                                                            () => {
                                                                                return this.state.copySnippetLabel
                                                                            },
                                                                            3000
                                                                        ]}
                                                                    />

                                                                    <pre className="row">
                                                                        <div className="col-md-12" role="alert">
                                                                            <Highlight className="java">{this.state.sdkSnippet}</Highlight>
                                                                        </div>
                                                                        <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                            <button
                                                                                className="btn btn-primary  btn-sm "
                                                                                onClick={this.copyClipboard.bind(this, this.state.sdkSnippet)}>
                                                                                <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                            </button>
                                                                        </div>
                                                                    </pre>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col">
                                                                <h3>Java SDK Upload Code Snippet</h3>
                                                            </div>
                                                        </div>

                                                        <div className="row" style={{ padding: '10px' }}>
                                                            <div className="col-12">
                                                                <p>
                                                                    This is an example of integration with the AudienceRate SDK in Java to Upload some files:
                                                                    (for more info check out our library here:{' '}
                                                                    <a target="_blank" href="https://github.com/audiencerate/dashboard-api-sdk">
                                                                        https://github.com/audiencerate/dashboard-api-sdk
                                                                    </a>
                                                                    ) &#160;
                                                                    <a
                                                                        className="btn btn-primary btn-sm"
                                                                        data-toggle="collapse"
                                                                        href="#collapseExample"
                                                                        role="button"
                                                                        aria-expanded="false"
                                                                        aria-controls="collapseExample"
                                                                        onClick={() => {
                                                                            this.setState({ showSDKUploadSnippet: !this.state.showSDKUploadSnippet })
                                                                        }}>
                                                                        {!this.state.showSDKUploadSnippet && <span>Show</span>}
                                                                        {this.state.showSDKUploadSnippet && <span>Hide</span>}
                                                                    </a>
                                                                </p>

                                                                <div style={{ display: this.state.showSDKUploadSnippet ? 'block' : 'none' }}>
                                                                    <ReactTooltip
                                                                        className="customeTooltipTheme"
                                                                        place="left"
                                                                        type="dark"
                                                                        effect="solid"
                                                                        getContent={[
                                                                            () => {
                                                                                return this.state.copySnippetLabel
                                                                            },
                                                                            3000
                                                                        ]}
                                                                    />

                                                                    <pre className="row">
                                                                        <div className="col-md-12" role="alert">
                                                                            <Highlight className="java">{this.state.sdkUploadSnippet}</Highlight>
                                                                        </div>
                                                                        <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                            <button
                                                                                className="btn btn-primary  btn-sm "
                                                                                onClick={this.copyClipboard.bind(this, this.state.sdkUploadSnippet)}>
                                                                                <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                            </button>
                                                                        </div>
                                                                    </pre>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col">
                                                                <h3>Python AWS SDK Upload Code Snippet</h3>
                                                            </div>
                                                        </div>

                                                        <div className="row" style={{ padding: '10px' }}>
                                                            <div className="col-12">
                                                                <p>
                                                                    This is an example of integration with AWS SDK Library in the python programming language.
                                                                    &#160;
                                                                    <a
                                                                        className="btn btn-primary btn-sm"
                                                                        data-toggle="collapse"
                                                                        href="#collapseExample"
                                                                        role="button"
                                                                        aria-expanded="false"
                                                                        aria-controls="collapseExample"
                                                                        onClick={() => {
                                                                            this.setState({ showSDKPyUploadSnippet: !this.state.showSDKPyUploadSnippet })
                                                                        }}>
                                                                        {!this.state.showSDKPyUploadSnippet && <span>Show</span>}
                                                                        {this.state.showSDKPyUploadSnippet && <span>Hide</span>}
                                                                    </a>
                                                                </p>

                                                                <div style={{ display: this.state.showSDKPyUploadSnippet ? 'block' : 'none' }}>
                                                                    <ReactTooltip
                                                                        className="customeTooltipTheme"
                                                                        place="left"
                                                                        type="dark"
                                                                        effect="solid"
                                                                        getContent={[
                                                                            () => {
                                                                                return this.state.copySnippetLabel
                                                                            },
                                                                            3000
                                                                        ]}
                                                                    />

                                                                    <pre className="row">
                                                                        <div className="col-md-12" role="alert">
                                                                            <Highlight className="python">{this.state.sdkPyUploadSnippet}</Highlight>
                                                                        </div>
                                                                        <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                            <button
                                                                                className="btn btn-primary  btn-sm "
                                                                                onClick={this.copyClipboard.bind(this, this.state.sdkPyUploadSnippet)}>
                                                                                <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                            </button>
                                                                        </div>
                                                                    </pre>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col">
                                                                <h3>Aws cli Login Code Snippet</h3>
                                                            </div>
                                                        </div>

                                                        <div className="row" style={{ padding: '10px' }}>
                                                            <div className="col-12">
                                                                <p>
                                                                    This is an example using the cross platform{' '}
                                                                    <a href="https://aws.amazon.com/cli/">aws cli tools</a> from the command-line, to show off
                                                                    under the hood the steps needed to login and make an API call to Audiencerate Dashboard.
                                                                    <br />
                                                                    Use those aws cli command from the aws user you enabled in the "Upload S3 Settings" and
                                                                    after you attached the policy. &#160;
                                                                    <a
                                                                        className="btn btn-primary btn-sm"
                                                                        data-toggle="collapse"
                                                                        href="#collapseExample"
                                                                        role="button"
                                                                        aria-expanded="false"
                                                                        aria-controls="collapseExample"
                                                                        onClick={() => {
                                                                            this.setState({ showCMDLoginSnippet: !this.state.showCMDLoginSnippet })
                                                                        }}>
                                                                        {!this.state.showCMDLoginSnippet && <span>Show</span>}
                                                                        {this.state.showCMDLoginSnippet && <span>Hide</span>}
                                                                    </a>
                                                                </p>

                                                                <div style={{ display: this.state.showCMDLoginSnippet ? 'block' : 'none' }}>
                                                                    <ReactTooltip
                                                                        className="customeTooltipTheme"
                                                                        place="left"
                                                                        type="dark"
                                                                        effect="solid"
                                                                        getContent={[
                                                                            () => {
                                                                                return this.state.copySnippetLabel
                                                                            },
                                                                            3000
                                                                        ]}
                                                                    />

                                                                    <pre className="row">
                                                                        <div className="col-md-12" role="alert">
                                                                            <Highlight className="bash">{this.state.cmdLoginSnippet}</Highlight>
                                                                        </div>
                                                                        <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                            <button
                                                                                className="btn btn-primary  btn-sm "
                                                                                onClick={this.copyClipboard.bind(this, this.state.cmdLoginSnippet)}>
                                                                                <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                            </button>
                                                                        </div>
                                                                    </pre>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col">
                                                                <h3>Aws cli Upload Code Snippet</h3>
                                                            </div>
                                                        </div>

                                                        <div className="row" style={{ padding: '10px' }}>
                                                            <div className="col-12">
                                                                <p>
                                                                    This is an example of making an upload using the cross platform{' '}
                                                                    <a href="https://aws.amazon.com/cli/">aws cli tools</a> from the command-line, to show off
                                                                    the steps needed to make an upload and how authenticate the API calls to the Audiencerate
                                                                    Dashboard.
                                                                    <br />
                                                                    Use those aws cli command from the aws user you enabled in the "Upload S3 Settings" and
                                                                    after you attached the policy. &#160;
                                                                    <a
                                                                        className="btn btn-primary btn-sm"
                                                                        data-toggle="collapse"
                                                                        href="#collapseExample"
                                                                        role="button"
                                                                        aria-expanded="false"
                                                                        aria-controls="collapseExample"
                                                                        onClick={() => {
                                                                            this.setState({ showCMDUploadSnippet: !this.state.showCMDUploadSnippet })
                                                                        }}>
                                                                        {!this.state.showCMDUploadSnippet && <span>Show</span>}
                                                                        {this.state.showCMDUploadSnippet && <span>Hide</span>}
                                                                    </a>
                                                                </p>

                                                                <div style={{ display: this.state.showCMDUploadSnippet ? 'block' : 'none' }}>
                                                                    <ReactTooltip
                                                                        className="customeTooltipTheme"
                                                                        place="left"
                                                                        type="dark"
                                                                        effect="solid"
                                                                        getContent={[
                                                                            () => {
                                                                                return this.state.copySnippetLabel
                                                                            },
                                                                            3000
                                                                        ]}
                                                                    />

                                                                    <pre className="row">
                                                                        <div className="col-md-12" role="alert">
                                                                            <Highlight className="bash">{this.state.cmdUploadS3Snippet}</Highlight>
                                                                        </div>
                                                                        <div data-tip={this.state.copySnippetLabel} className="clipboard-button">
                                                                            <button
                                                                                className="btn btn-primary  btn-sm "
                                                                                onClick={this.copyClipboard.bind(this, this.state.cmdUploadS3Snippet)}>
                                                                                <i className="fa fa-clone" style={{ margin: '0 !important' }} />
                                                                            </button>
                                                                        </div>
                                                                    </pre>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </WhiteBox>
                                </div>
                            </div>
                        )}
                    </Multi>
                </div>
            </PageWrapper>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    state => ({}),
    mapDispatchToProps
)(SettingsServerToServer)
